import React, { useMemo } from 'react';

import {
  FiltersCollection,
  ScreenAllFilters,
  UnAppliedChanges,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { CollapsibleBlock } from '@gogame/components';
import {
  Screen,
  withScreen,
  createScreenRoute,
  SET_FILTERS,
  useScreenDispatch,
} from '@gogame/screens';

import AllFilters from './components/Filters/AllFilters';
import ApplyFiltersButton from './components/Filters/ApplyFiltersButton';
import PrimaryFilters from './components/Filters/PrimaryFilters';
import HourlyTrackerChartV2 from './components/HourlyTrackerCharts';
import HourlyTrackerDataTable from './components/HourlyTrackerDataTable';
import { SCREEN_NAME } from './constants';
import { permission } from './constants';
import { hourlyTrackerLink, hourlyTrackerSearchParams } from './navigation';
import { ensureTemporaryState } from './reducers/hourlyTrackerTemporaryStateReducer';
import { hourlyTrackerTemporaryStateReducer, APPLY } from './reducers/index';
import {
  EMPTY_FILTERS,
  mapStateToPreset,
  mapPresetToState,
  baseCompareSchema,
  compareSchema,
} from './schemas';

const id = 3;
export { mapStateToPreset, mapPresetToState };

const HourlyTracker = withScreen({
  name: SCREEN_NAME,
  searchParams: hourlyTrackerSearchParams,
  reducer: hourlyTrackerTemporaryStateReducer,
})(({ screenState }) => {
  const dispatch = useScreenDispatch();
  const filtersCollection = useMemo(() => {
    return ensureTemporaryState(screenState).filtersCollection;
  }, [screenState]);

  const handleApplyCollection = () =>
    dispatch({
      type: APPLY,
    });

  const handleCompare = (baseFilters) => [
    baseCompareSchema.cast(baseFilters, {
      stripUnknown: true,
    }),
    compareSchema.cast(baseFilters, {
      stripUnknown: true,
    }),
  ];

  const handleSetCollection = (filtersCollection) =>
    dispatch({
      type: SET_FILTERS,
      payload: filtersCollection,
    });

  return (
    <React.Fragment>
      <Screen.Toolbar />
      {screenState.ready && screenState.temporary ? <UnAppliedChanges /> : null}
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />

        <FiltersCollection
          screen={SCREEN_NAME}
          controlled={true}
          initialValues={filtersCollection}
          emptyValues={EMPTY_FILTERS}
          onChange={handleSetCollection}
          onCompare={handleCompare}
        >
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters}></ScreenAllFilters>
          <Screen.Toolbar.FiltersApply>
            <ApplyFiltersButton onClick={handleApplyCollection} />
          </Screen.Toolbar.FiltersApply>
        </FiltersCollection>
        <CollapsibleBlock showLabel={'Show charts'} hideLabel={'Hide charts'}>
          <HourlyTrackerChartV2 />
        </CollapsibleBlock>
        <HourlyTrackerDataTable />
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Hourly Tracker',
  link: hourlyTrackerLink,
  screen: <HourlyTracker />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360026371754-Hourly-Tracker',
});
